export class WidgetEnabledState {
    public message: string;
    public enabled: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/WidgetEnabledState.ts